import TableCellDescription from "ds/components/Table/Row/CellDescription";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { StackOutput } from "types/generated";

type OutputWithStack = StackOutput & {
  stackId: string;
  stackName: string;
};

const TemplateDeploymentOutputsDescriptionCell = ({
  item: output,
  ...cellProps
}: TableSimpleCellProps<OutputWithStack>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellDescription description={output.description} />
    </TableSimpleCell>
  );
};

export default TemplateDeploymentOutputsDescriptionCell;
